import { render, staticRenderFns } from "./AccountOrgaWaitingForReview.vue?vue&type=template&id=268a6932&"
import script from "./AccountOrgaWaitingForReview.vue?vue&type=script&lang=ts&"
export * from "./AccountOrgaWaitingForReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports